import { useAppDispatch, useAppSelector } from 'hooks/store/useAppStore';
import { set } from 'store/slices/appTitleSlice';

interface IUseAppTitleReturn {
    appTitle: string;
    setAppTitle: (value: string) => void;
    setDefaultAppTitle: () => void;
}

export const useAppTitle = (): IUseAppTitleReturn => {
    const appTitle = useAppSelector((state) => state.appTitle.value);

    const dispatch = useAppDispatch();

    const setAppTitle = (value: string): void => {
        document.title = `${value} | Государственный доклад - О состоянии и об охране окружающей среды Российской Федерации в 2021 году`;
        dispatch(set(value));
    };

    const setDefaultAppTitle = (): void => {
        document.title = `Государственный доклад - О состоянии и об охране окружающей среды Российской Федерации в 2021 году`;
        dispatch(
            set(
                'Государственный доклад - О состоянии и об охране окружающей среды Российской Федерации в 2021 году'
            )
        );
    };

    return { appTitle, setAppTitle, setDefaultAppTitle };
};
